import { FormKitTypeDefinition } from '@formkit/core'
import {
  outer,
  inner,
  wrapper,
  label,
  help,
  messages,
  message,
  prefix,
  suffix,
  icon,
  selectInput,
  option,
  optionSlot,
  optGroup,
  $if,
  options,
  selects,
  defaultIcon,
} from '../compose'

/**
 * Input definition for a select.
 * @public
 */
export const select: FormKitTypeDefinition = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* #__PURE__ */ outer(
    /* #__PURE__ */ wrapper(
      /* #__PURE__ */ label('$label'),
      /* #__PURE__ */ inner(
        /* #__PURE__ */ icon('prefix'),
        /* #__PURE__ */ prefix(),
        /* #__PURE__ */ selectInput(
          $if(
            '$slots.default',
            () => '$slots.default',
            /* #__PURE__ */ optionSlot(
              $if(
                '$option.group',
                /* #__PURE__ */ optGroup(/* #__PURE__ */ optionSlot(/* #__PURE__ */ option('$option.label'))),
                /* #__PURE__ */ option('$option.label')
              )
            )
          )
        ),
        $if('$attrs.multiple !== undefined', () => '', /* #__PURE__ */ icon('select')),
        /* #__PURE__ */ suffix(),
        /* #__PURE__ */ icon('suffix')
      )
    ),
    /* #__PURE__ */ help('$help'),
    /* #__PURE__ */ messages(/* #__PURE__ */ message('$message.value'))
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: 'input',
  /**
   * An array of extra props to accept for this input.
   */
  props: ['options', 'placeholder', 'optionsLoader'],
  /**
   * Additional features that should be added to your input
   */
  features: [options, selects, defaultIcon('select', 'select')],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: 'cb119h43krg',
}
